(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.sd-carousel').forEach(function (el) {
      var track  = el.querySelector('.sd-carousel__track');
      var slides = el.querySelectorAll('.sd-carousel__slide');
      var dots   = el.querySelectorAll('.sd-carousel__dot');
      var idx    = 0;
      var autoplay = el.dataset.autoplay === 'true';
      var speed    = parseInt(el.dataset.speed) || 4000;

      function updateActiveClasses() {
        slides.forEach(function (slide, i) {
          slide.classList.remove('is-active');
          // On desktop, the middle slide (index + 1) is active
          if (window.innerWidth >= 768) {
            if (i === idx + 1) {
              slide.classList.add('is-active');
            }
          } else {
            // On mobile, the current index slide is active
            if (i === idx) {
              slide.classList.add('is-active');
            }
          }
        });
      }

      function go(n) {
        var maxIdx = slides.length - 1;
        
        // On desktop, adjust max index so we don't scroll past the view edge
        if (window.innerWidth >= 768) {
          maxIdx = slides.length - 3;
          if (maxIdx < 0) maxIdx = 0;
        }

        idx = (n + (maxIdx + 1)) % (maxIdx + 1);
        
        var percentage = window.innerWidth >= 768 ? idx * 33.333 : idx * 100;
        track.style.transform = 'translateX(-' + percentage + '%)';
        
        dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
        updateActiveClasses();
      }

      el.querySelector('.sd-carousel__btn--prev').addEventListener('click', function () { go(idx - 1); });
      el.querySelector('.sd-carousel__btn--next').addEventListener('click', function () { go(idx + 1); });
      
      dots.forEach(function (d, i) { 
        d.addEventListener('click', function () { go(i); }); 
      });

      // Recalculate on window resize
      window.addEventListener('resize', function() {
        go(idx);
      });

      updateActiveClasses();

      if (autoplay) { 
        setInterval(function () { 
          var limit = window.innerWidth >= 768 ? slides.length - 3 : slides.length - 1;
          var nextIdx = idx >= limit ? 0 : idx + 1;
          go(nextIdx); 
        }, speed); 
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.sd2-carousel').forEach(function (el) {
      if (el.dataset.sd2Init) return;
      el.dataset.sd2Init = 'true';

      var track    = el.querySelector('.sd2-carousel__track');
      var slides   = el.querySelectorAll('.sd2-carousel__slide');
      var dots     = el.querySelectorAll('.sd2-carousel__dot');
      var prevBtn  = el.querySelector('.sd2-carousel__btn--prev');
      var nextBtn  = el.querySelector('.sd2-carousel__btn--next');
      var idx      = 0;
      var autoplay = el.dataset.autoplay === 'true';
      var speed    = parseInt(el.dataset.speed) || 4000;
      var timer    = null;

      function go(n) {
        var total = slides.length;
        if (!total) return;
        idx = (n + total) % total;
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
        dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
      }

      function start() {
        if (!autoplay || slides.length < 2) return;
        stop();
        timer = setInterval(function () { go(idx + 1); }, speed);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1); start(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1); start(); });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { go(i); start(); });
      });

      // Swipe support on touch devices
      var startX = 0;
      el.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      el.addEventListener('touchend', function (e) {
        var diff = e.changedTouches[0].clientX - startX;
        if (Math.abs(diff) > 50) { go(diff < 0 ? idx + 1 : idx - 1); start(); }
      }, { passive: true });

      go(0);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.sd3-carousel').forEach(function (el) {
      if (el.dataset.sd3Init) return;
      el.dataset.sd3Init = 'true';

      var track    = el.querySelector('.sd3-carousel__track');
      var slides   = el.querySelectorAll('.sd3-carousel__slide');
      var dots     = el.querySelectorAll('.sd3-carousel__dot');
      var prevBtn  = el.querySelector('.sd3-carousel__btn--prev');
      var nextBtn  = el.querySelector('.sd3-carousel__btn--next');
      var idx      = 0;
      var autoplay = el.dataset.autoplay === 'true';
      var speed    = parseInt(el.dataset.speed) || 4000;
      var timer    = null;

      function go(n) {
        var total = slides.length;
        if (!total) return;
        idx = (n + total) % total;
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
        dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
      }

      function start() {
        if (!autoplay || slides.length < 2) return;
        stop();
        timer = setInterval(function () { go(idx + 1); }, speed);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1); start(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1); start(); });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { go(i); start(); });
      });

      // Swipe support on touch devices
      var startX = 0;
      el.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      el.addEventListener('touchend', function (e) {
        var diff = e.changedTouches[0].clientX - startX;
        if (Math.abs(diff) > 50) { go(diff < 0 ? idx + 1 : idx - 1); start(); }
      }, { passive: true });

      go(0);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
